import { format_date } from "../../Utils/helpers";

export const isAccountDeleted = (item) => Boolean(item?.isDeleted);

export const isDeletionPending = (item) => Boolean(item?.deletionScheduledFor) && !item?.isDeleted;

export default function AccountDeletionBadge({ item, className = "ms-1" }) {
  if (isAccountDeleted(item)) {
    return (
      <span
        className={`status-pill status-inactive ${className}`.trim()}
        title={item?.deletedAt ? `Deleted on ${format_date(item.deletedAt, "MM/DD/YYYY")}` : "Deleted"}
      >
        Deleted
      </span>
    );
  }
  if (isDeletionPending(item)) {
    return (
      <span
        className={`status-pill status-pending ${className}`.trim()}
        title={
          item?.deletionRequestedBy === "admin"
            ? "Closed by admin. Only an admin can cancel it (Cancel Deletion)."
            : "Requested by the account holder. Logging in before this date cancels it."
        }
      >
        Deletion on {format_date(item.deletionScheduledFor, "MM/DD/YYYY")}
      </span>
    );
  }
  return null;
}
